RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.ShareLandscapeModal = Marionette.ItemView.extend({
        ui: {
            modal: '.modal',
            urlBox: 'input[name="url"]'
        },

        events: {
            'shown.bs.modal': 'onModalShown'
        },

        template: '#commonShareLandscapeModalTemplate',

        onRender: function () {
            const me = this;
            me.ui.modal.modal();
        },

        onModalShown: function () {
            const me = this;
            me.ui.urlBox.select();
        }
    });
});
